module.exports = __webpack_public_path__ + "img/enkai-jyou.85c51697.jpg";